import React from "react";
import { Col, Button, Form, FormGroup, Alert } from "react-bootstrap";
import _isEmpty from "lodash/isEmpty";

export default class OrderUnitProductCreator extends React.Component {
  constructor(props) {
    super(props);

    this.orderUnitProductCountInput = React.createRef();
    this.orderUnitProductSelectInput = React.createRef();
  }

  add(event) {
    event.preventDefault();

    this.props.addFn(
      this.props.orderUnit,
      this.orderUnitProductSelectInput.current.value,
      this.orderUnitProductCountInput.current.value,
    );
    this.orderUnitProductSelectInput.current.form.reset();
  }

  render() {
    const { allProducts, orderUnit } = this.props;
    const usedProductIds = (orderUnit.orderUnitsProducts || []).map(
      oup => `${oup.productId}`,
    );
    const unusedProducts = allProducts.filter(
      product => !usedProductIds.includes(`${product.id}`),
    );

    return (
      <Form
        horizontal
        onSubmit={this.add.bind(this)}
        className="order-unit-product-creator"
        id="order-unit-product-creator"
      >
        <p className="order-unit-heading">Produktauswahl</p>
        <Choose>
          <When condition={this.props.isSubmitting}>
            <FormSpinner />
          </When>
          <When condition={_isEmpty(allProducts)}>
            <Alert>Derzeit gibt es keine Produkte zur Auswahl.</Alert>
          </When>
          <When condition={unusedProducts.length > 0}>
            <OrderUnitProductForm
              unusedProducts={unusedProducts}
              orderUnitProductCountInputRef={this.orderUnitProductCountInput}
              orderUnitProductSelectInputRef={this.orderUnitProductSelectInput}
            />
          </When>
          <When condition={_isEmpty(unusedProducts)}>
            <Alert>
              Du hast alle eure Produkte zu dieser Bestelleinheit hinzugefügt.
            </Alert>
          </When>
        </Choose>
        <span className="visible-xs-block">
          <hr />
        </span>
      </Form>
    );
  }
}

const FormSpinner = () => {
  return (
    <div className="order-unit-form-spinner">
      <i className="fa fa-spinner fa-spin" />
    </div>
  );
};

const OrderUnitProductForm = props => {
  const {
    unusedProducts,
    orderUnitProductSelectInputRef,
    orderUnitProductCountInputRef,
  } = props;

  return (
    <div>
      <FormGroup>
        <Col xs={12} md={2}>
          <input
            type="number"
            required
            className="form-control"
            ref={orderUnitProductCountInputRef}
            min="1"
            step="1"
            placeholder="Anzahl"
          />
        </Col>
        <Col xs={12} md={5}>
          <select
            id="order-unit-product-creator-select"
            required
            className="form-control"
            ref={orderUnitProductSelectInputRef}
          >
            <option value="">Bitte Produkt auswählen</option>
            {unusedProducts.map(product => {
              return (
                <option value={product.id} key={`product-option-${product.id}`}>
                  {product.productVariantName}
                </option>
              );
            })}
          </select>
        </Col>
        <Col xs={12} md={2}>
          <Button type="submit">Hinzufügen</Button>
        </Col>
      </FormGroup>
    </div>
  );
};
